import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../lib/api";
import { toast } from "sonner";

export default function RecruiterLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/recruiters/login", { email, password });
      localStorage.setItem("cct_recruiter_token", data.token);
      localStorage.setItem("cct_recruiter", JSON.stringify(data.recruiter));
      toast.success(`Welcome, ${data.recruiter.full_name}`);
      navigate("/recruiter/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cct-ambient">
      <Header />
      <main className="max-w-md mx-auto px-4 pb-20">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-cct-blue mb-6"
        >
          <ArrowLeft className="w-4 h-4" /> Back to portal
        </Link>
        <div className="fade-up bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
          <h1 className="font-display text-3xl font-semibold text-cct-blue">
            Recruiter Login
          </h1>
          <p className="mt-1 text-sm text-slate-600">
            Access your partner dashboard
          </p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 w-full rounded-md border border-slate-300 bg-white px-3.5 py-2.5 text-sm input-focus"
              />
            </label>
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5 w-full rounded-md border border-slate-300 bg-white px-3.5 py-2.5 text-sm input-focus"
              />
            </label>
            <button
              disabled={loading}
              className="w-full bg-cct-blue text-white font-semibold py-2.5 rounded-md hover:bg-[#1a3380] disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-200 text-sm text-center text-slate-600">
            New partner?{" "}
            <Link
              to="/recruiter-signup"
              className="font-medium text-cct-blue hover:underline"
            >
              Sign up here
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
